import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

type Props = {
  title: string;
  children: React.ReactNode;
};

const LegalOverlay: React.FC<Props> = ({ title, children }) => {
  const navigate = useNavigate();
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') navigate(-1);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [navigate]);

  useEffect(() => {
    panelRef.current?.focus();
  }, []);

  return (
    <div className="fixed inset-0 z-[1300]">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={() => navigate(-1)}
        aria-hidden="true"
      />

      <div className="absolute inset-0 flex justify-center p-3 sm:p-6">
        <div
          ref={panelRef}
          tabIndex={-1}
          className="w-full max-w-5xl h-full rounded-xl border border-border bg-background text-foreground shadow-2xl overflow-hidden focus:outline-none"
          role="dialog"
          aria-modal="true"
          aria-label={title}
        >
          <div className="h-14 px-4 border-b border-border bg-card flex items-center justify-between">
            <div className="flex items-center gap-2 min-w-0">
              <div className="h-8 w-8 rounded-md bg-primary/10 flex items-center justify-center">
                <Icon name="Scale" size={18} className="text-primary" />
              </div>
              <div className="min-w-0">
                <div className="text-sm font-semibold truncate">{title}</div>
                <div className="text-xs text-muted-foreground truncate">
                  Document informativ (conținut în curs de completare)
                </div>
              </div>
            </div>
            <button
              type="button"
              className="h-9 w-9 inline-flex items-center justify-center rounded-md hover:bg-muted focus:outline-none focus:ring-2 focus:ring-primary"
              onClick={() => navigate(-1)}
              aria-label="Închide"
            >
              <Icon name="X" size={18} />
            </button>
          </div>

          <div className="h-[calc(100%-3.5rem)] overflow-auto">
            <div className="mx-auto max-w-4xl px-4 py-8">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalOverlay;

